import BlogBN from "./BlogBN.js";
import NewsLetter from "./NewsLetter";
import ContactBN from "./ContactBN.js";
import ScrollToTopButton from "./ScrollToTopButton";

function SideBox() {
  return (
    <div className="side_box contents4">
      <BlogBN />
      <NewsLetter />
      <ContactBN />
      <ScrollToTopButton />
    </div>
  );
}

export default SideBox;
